import { render, staticRenderFns } from "./ResetPasswordPhoneCard.vue?vue&type=template&id=79210e89&scoped=true&"
import script from "./ResetPasswordPhoneCard.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordPhoneCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79210e89",
  null
  
)

export default component.exports